function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#2a343f;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.6px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2519",
  "data-name": "Group 2519",
  transform: "translate(.8 1.117)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2521",
  "data-name": "Group 2521"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2520",
  "data-name": "Group 2520",
  transform: "translate(9.909 1.209)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3588",
  "data-name": "Path 3588",
  className: "cls-1",
  d: "M896.828 236.379a8.716 8.716 0 0 1-.573 2.666 2.683 2.683 0 0 0 2.312.753c2.259-.533 1.909 1.332 1.3 2.456s-1.975 2.439-2.768.257a2.681 2.681 0 0 0-1.9-1.521 8.719 8.719 0 0 1-1.979 1.987",
  transform: "translate(-875.247 -223.057)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3589",
  "data-name": "Path 3589",
  className: "cls-1",
  d: "M894.161 228.191a3.616 3.616 0 0 0 3.934-.974c1.221-1.974 2.292-.408 2.658.816s.328 3.121-1.775 2.14a3.614 3.614 0 0 0-3.823 1.343",
  transform: "translate(-875.642 -218.797)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3590",
  "data-name": "Path 3590",
  className: "cls-1",
  d: "M891.746 221.62a8.686 8.686 0 0 0-1.946-1.92 2.681 2.681 0 0 1 1.522-1.9c2.181-.794.866-2.161-.258-2.768s-2.988-.957-2.456 1.3a2.68 2.68 0 0 1-.753 2.312 8.715 8.715 0 0 0-2.744-.577",
  transform: "translate(-871.827 -213.865)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3591",
  "data-name": "Path 3591",
  className: "cls-1",
  d: "M883.7 246.937a3.674 3.674 0 0 1 1.41 4c-1.082 2.216 1.244 2.152 2.57 1.757s3.305-1.618 1.186-2.878a3.674 3.674 0 0 1-1.011-4.114",
  transform: "translate(-871.229 -226.986)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3592",
  "data-name": "Path 3592",
  className: "cls-1",
  d: "M870.867 244.749a8.687 8.687 0 0 0 1.941 1.915 2.681 2.681 0 0 1-1.521 1.9c-2.182.794-.867 2.161.257 2.768s2.988.957 2.456-1.3a2.679 2.679 0 0 1 .753-2.312 8.721 8.721 0 0 0 2.744.577",
  transform: "translate(-865.499 -226.587)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3593",
  "data-name": "Path 3593",
  className: "cls-1",
  d: "M867.91 236.165a3.614 3.614 0 0 1-3.823 1.343c-2.1-.981-2.141.915-1.775 2.14s1.437 2.79 2.658.816a3.616 3.616 0 0 1 3.934-.974",
  transform: "translate(-862.136 -222.966)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3594",
  "data-name": "Path 3594",
  className: "cls-1",
  d: "M875.7 220.548a3.538 3.538 0 0 0-1.011-4.115c-2.119-1.26-.14-2.482 1.186-2.878s3.652-.459 2.57 1.757a3.55 3.55 0 0 0 1.411 4",
  transform: "translate(-867.038 -213.341)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3595",
  "data-name": "Path 3595",
  className: "cls-1",
  d: "M865.994 229.792a8.716 8.716 0 0 1 .573-2.666 2.683 2.683 0 0 0-2.312-.753c-2.259.533-1.91-1.332-1.3-2.456s1.974-2.439 2.768-.257a2.683 2.683 0 0 0 1.9 1.521 8.723 8.723 0 0 1 1.979-1.987",
  transform: "translate(-862.289 -217.197)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3596",
  "data-name": "Path 3596",
  className: "cls-1",
  d: "M891.1 237.205a1.735 1.735 0 1 0-1.166 2.159 1.735 1.735 0 0 0 1.166-2.159z",
  transform: "translate(-872.917 -222.883)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3597",
  "data-name": "Path 3597",
  className: "cls-1",
  d: "M887.564 228.868a1.735 1.735 0 1 0-1.166 2.158 1.735 1.735 0 0 0 1.166-2.158z",
  transform: "translate(-871.427 -219.366)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3598",
  "data-name": "Path 3598",
  className: "cls-1",
  d: "M877.41 229.812a1.735 1.735 0 1 0-1.166 2.159 1.734 1.734 0 0 0 1.166-2.159z",
  transform: "translate(-867.145 -219.765)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3599",
  "data-name": "Path 3599",
  className: "cls-1",
  d: "M881.229 239.108a1.735 1.735 0 1 0-1.166 2.159 1.735 1.735 0 0 0 1.166-2.159z",
  transform: "translate(-868.755 -223.685)"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_3600",
  "data-name": "Path 3600",
  className: "cls-1",
  d: "M867.251 240.784a48.343 48.343 0 0 1-7.775 5.049c-.817-.212-14.477-8.221-14.477-13.673v-15.28c4.084 0 13.047-3.658 14.477-5.63",
  transform: "translate(-845 -211.25)"
})));

function SvgHomeIconGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36.807,
    height: 36.501,
    viewBox: "0 0 36.807 36.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconGray);
export default __webpack_public_path__ + "static/media/home-icon-gray.3e56702f.svg";
export { ForwardRef as ReactComponent };